// #3173 — side-effect module, imported FIRST by main.jsx: strips the magic-link
// token and email from the URL before Sentry or PostHog can read it.
// #3258 — the same for the digest-unsubscribe token in /unsubscribe/digest/<token>.
// See lib/auth/magicLinkUrlScrub.js.
import {
  scrubMagicLinkFromLocation,
  scrubDigestUnsubscribeFromLocation,
} from './lib/auth/magicLinkUrlScrub.js';

scrubMagicLinkFromLocation();
scrubDigestUnsubscribeFromLocation();
